import { Divider, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

interface Props {
  label: string
  leftItems: { key: string; value: number }[]
  rightItems: { key: string; value: number }[]
}

export const VesselBookingSummaryItem = observer(({ label, leftItems, rightItems }: Props) => {
  const Item: FC<{ label: string; value: number }> = ({ label, value }) => {
    return (
      <Stack direction='row' alignItems='center' gap={1}>
        <Typography variant='subtitle2'>{label}</Typography>
        <Typography variant='h5'>{value}</Typography>
      </Stack>
    )
  }

  return (
    <Stack
      direction='row'
      width={'100%'}
      justifyContent={'space-evenly'}
      alignItems='center'
      gap={2}
      padding={2}
    >
      <Typography variant='subtitle2' color='secondary'>
        {label}
      </Typography>
      {leftItems.map(({ key, value }) => (
        <Item key={key} label={key} value={value} />
      ))}
      <Divider orientation='vertical' flexItem />
      {rightItems.map(({ key, value }) => (
        <Item key={key} label={key} value={value} />
      ))}
    </Stack>
  )
})
